<template>
  <aside v-if="visible" class="erp-phone-incoming-sidebar">
    <div class="erp-phone-incoming-sidebar__header">
      <div>
        <span class="erp-phone-incoming-sidebar__badge">Incoming call</span>
        <h5>{{ callerName }}</h5>
        <p>{{ callerNumber }}</p>
      </div>
      <button class="erp-phone-icon-btn" type="button" @click="dismissSidebar">×</button>
    </div>

    <div class="erp-phone-incoming-sidebar__body">
      <div v-if="leadLookup.loading" class="erp-phone-empty">
        Looking up lead details...
      </div>
      <div v-else-if="leadLookup.error" class="erp-phone-alert erp-phone-alert--warning">
        {{ leadLookup.error }}
      </div>

      <div v-else-if="lead" class="erp-phone-lead-card">
        <h6>Lead details</h6>
        <dl class="erp-phone-lead-card__details">
          <div v-if="lead.fullname || lead.name">
            <dt>Name</dt>
            <dd>{{ lead.fullname || lead.name }}</dd>
          </div>
          <div v-if="lead.mobile">
            <dt>Mobile</dt>
            <dd>{{ lead.mobile }}</dd>
          </div>
          <div v-if="lead.city">
            <dt>City</dt>
            <dd>{{ lead.city }}</dd>
          </div>
          <div v-if="lead.area">
            <dt>Area</dt>
            <dd>{{ lead.area }}</dd>
          </div>
          <div v-if="lead.leadsource">
            <dt>Source</dt>
            <dd>{{ lead.leadsource }}</dd>
          </div>
          <div v-if="lead.leadcategory">
            <dt>Category</dt>
            <dd>{{ lead.leadcategory }}</dd>
          </div>
          <div v-if="lead.assignto_name">
            <dt>Assigned to</dt>
            <dd>{{ lead.assignto_name }}</dd>
          </div>
          <div v-if="lead.status">
            <dt>Status</dt>
            <dd>{{ lead.status }}</dd>
          </div>
          <div v-if="lead.nextfollowupdate">
            <dt>Next follow-up</dt>
            <dd>{{ formatDate(lead.nextfollowupdate) }}</dd>
          </div>
        </dl>
        <button class="erp-phone-btn erp-phone-btn--primary erp-phone-btn--block" type="button" @click="goToFollowup">
          Follow up
        </button>
      </div>

      <div v-else class="erp-phone-lead-card erp-phone-lead-card--empty">
        <h6>No lead found</h6>
        <p>This number is not in your lead list.</p>
        <button class="erp-phone-btn erp-phone-btn--primary erp-phone-btn--block" type="button" @click="goToAddLead">
          Add lead
        </button>
      </div>
    </div>

    <div v-if="incomingCall" class="erp-phone-incoming-sidebar__footer">
      <button class="erp-phone-btn erp-phone-btn--success" type="button" @click="answerCall">Answer</button>
      <button class="erp-phone-btn erp-phone-btn--danger" type="button" @click="rejectCall">Reject</button>
    </div>
  </aside>
</template>

<script>
import { phoneService } from '@/services/phoneService'

export default {
  name: 'PhoneIncomingSidebar',
  computed: {
    phoneState () {
      return this.$store.state.phone
    },
    incomingCall () {
      return this.phoneState.incomingCall
    },
    activeCall () {
      return this.phoneState.activeCall
    },
    leadLookup () {
      return this.phoneState.incomingLeadLookup
    },
    lead () {
      return this.leadLookup.found
    },
    visible () {
      return !!this.incomingCall || (this.activeCall && this.activeCall.direction === 'incoming')
    },
    callerName () {
      return this.incomingCall?.remoteName || this.activeCall?.remoteName || 'Unknown caller'
    },
    callerNumber () {
      return this.incomingCall?.remoteNumber || this.activeCall?.remoteNumber || this.leadLookup.phone || ''
    }
  },
  methods: {
    async answerCall () {
      await phoneService.answer()
    },
    async rejectCall () {
      await phoneService.reject()
    },
    dismissSidebar () {
      if (this.incomingCall) {
        this.rejectCall()
        return
      }
      this.$store.commit('phone/RESET_INCOMING_LEAD_LOOKUP')
    },
    goToFollowup () {
      if (!this.lead?.id) return
      this.$router.push(`/followup/followupinfo?id=${this.lead.id}`).catch(() => {})
    },
    goToAddLead () {
      const mobile = String(this.callerNumber || '').replace(/\D/g, '').slice(-10)
      const query = mobile ? { mobile } : {}
      this.$router.push({ path: '/crm/addlead', query }).catch(() => {})
    },
    formatDate (value) {
      if (!value) return ''
      return new Date(value).toLocaleString()
    }
  }
}
</script>
